import * as R from 'ramda'

export default class QListAPI {
    constructor(http) {
        this.http = http
    }

    getClientSurveyTypes = async (clientId) => new Promise((resolve, reject) => {
        this.http.get(`/client/${clientId}/surveytype`)
            .then((response) => {
                resolve(response)
            })
            .catch((e) => {
                reject(e)
            })
    })

    getCustomCategoryOptions = async (customCategoryId) => new Promise((resolve, reject) => {
        this.http.get(`/vocabulary/term/${customCategoryId}/filter`)
            .then((response) => {
                resolve(response)
            })
            .catch((e) => {
                reject(e)
            })
    })

    getIndustries = async () => new Promise((resolve, reject) => {
        this.http.get('/client/industry')
            .then((response) => {
                resolve(response)
            })
            .catch((e) => {
                reject(e)
            })
    })

    getProductTypesByIndustry = async (industry) => new Promise((resolve, reject) => {
        this.http.get(`/producttype/${industry}`)
            .then((response) => {
                resolve(response)
            })
            .catch((e) => {
                reject(e)
            })
    })

    getProductTypes = async (industries) => {
        const productTypes = await Promise.all(
            industries.map((industry) => this.http.get(`/producttype/${industry}`)),
        )

        return industries.map((industry, index) => (
            R.pathOr([], [index], productTypes).map((productType) => (
                R.mergeLeft(productType, {
                    industry,
                })
            ))
        )).flat()
    }

    getRespondentTypes = async (producttype) => this.http.get(`/respondenttype/${producttype}`)

    getQlist = async (productType, respondentType, oid, rid, other = {}, surveyType = 'PE') => (
        new Promise((resolve, reject) => {
            let url = '/qlist/getQlists2?'
            url += '&productType=' + productType
            url += '&surveyType=' + surveyType
            url += '&respondentType=' + respondentType
            url += '&oid=' + oid
            url += '&recordId=' + rid
            url += '&history=1'
            url += '&cols=full'
            url += '&filter='
            url += '&orderby=priority'

            Object.keys(other).forEach((key) => {
                url += `&${key}=${other[key]}`
            })

            this.http.get(url)
                .then((response) => {
                    console.log(JSON.stringify(response, null, 4))
                    resolve(response)
                })
                .catch((e) => {
                    reject(e)
                })
        })
    )

    reorder = (qlistIds) => {
        console.log('reorder')
        return new Promise((resolve, reject) => {
            const url = '/qlist/reorder'
            console.log(qlistIds)
            const body = JSON.stringify({
                qlistIds,
            })
            this.http.put(url, body)
                .then((response) => {
                    console.log(response)
                    resolve(response)
                })
                .catch((e) => {
                    console.log(e)
                    reject(e)
                })
        })
    }

    insert = (question, clientId) => {
        const that = this
        return new Promise((resolve, reject) => {
            let url = '/qlist/update/'
            const body = JSON.stringify({
                questionId: question.questionId,
                clientId: that.store.appStore.tokenData.clientId,
                oid: that.store.oid,
                recordId: that.store.rid,
                producttypecode: that.store.eventType.value,
                surveytypecode: that.store.addingMaxbi ? 'EM' : this.store.surveyType.value,
                respondenttypecode: that.store.respondentType.value,
                mandatory: question.mandatory ? 1 : 0,
                surveymandatory: 1,
                priority: 1000,
            })
            that.http.post('/qlist/update', body)
                .then((data) => {
                    console.log(data)
                    resolve(data)
                })
                .catch((e) => {
                    console.log("ERROR!!!!: " + e)
                    reject(e)
                })
        })
    }

    update = (body) => {
        const that = this
        return new Promise((resolve, reject) => {
            that.http.put('/qlist/update', body)
                .then((data) => {
                    console.log(data)
                    resolve(data)
                })
                .catch((e) => {
                    console.log("ERROR!!!!: " + e)
                    reject(e)
                })
        })
    }

    getQuestionDetails = async (questionId) => {
        try {
            const res = await this.http.get(`/api/question/${questionId}/7`)
            return res
        } catch (e) {
            console.log(e)
        }
    }

    getQuestionCategories = async () => {
        try {
            return await this.http.get(`/qlist/${this.store.appStore.tokenData.clientId}/categories`)
        } catch (error) {
            console.log('getQuestionCategory ', error)
            return []
        }
    }
}
